import BaseModel from '../core/BaseModel'
import ServiceUnitModel from "./ServiceUnitModel";
//import {constants} from "../services/constants";
export default class ServiceSuppliesFormModel extends BaseModel {
    constructor() {
        super({
                name: "service_supplies_form",
                tableName: 'core_service_supplies',
                display_key: 'name'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                code: {
                    name: 'code',
                    type: "String",
                    label: 'Mã vật tư - dịch vụ',
                    filter: { type: 'input', match: 'custom', placeHolder: 'Nhập mã vật tư - dịch vụ'}
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: 'Tên vật tư - dịch vụ',
                    filter: { type: 'input', match: 'custom', placeHolder: 'Nhập tên vật tư - dịch vụ'}
                },
                unit: {
                    name: 'unit',
                    type: "Selection",
                    label: 'Đơn vị tính',
                    class: 'center',
                    dataType: 'Label',
                    width: 14,
                    sortable: true,
                    params: {select: 'code, name', variables: {status: {'_in': [1]}}},
                    models: new ServiceUnitModel(),
                    filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'}
                },
               /* unit_price_tmp: {
                    name: "unit_price_tmp",
                    label: "Đơn giá",
                    type: "Computed",
                    filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        console.log("data.unit_pricedata.unit_price:",data.unit_price);
                        data.unit_price_tmp = (!constants.isEmpty(data.unit_price)) ? constants.numberFormat(data.unit_price, 0, '', '.'):'0';
                    },
                    // display: { list: true, add: false, edit: false }
                },*/
                unit_price: {
                    name: 'unit_price',
                    type: "String",
                    label: 'Đơn giá (VNĐ)',
                    class: 'center right_td_unit_price',
                    filter: {type: 'input', match: 'contains'},
                    //display: false
                },
               /* obj_service_pack_service_supplies: {
                    refs: 'obj_service_pack_service_supplies { id service_supplier_id service_pack_id status modified_date }',
                    display: false
                },*/

            },)
    }

}